import { useEffect, useState } from 'react'
import { Clock, AlertTriangle } from 'lucide-react'
import { cn } from '../lib/utils'

interface Props {
  deadline: string | null | undefined
  breached: boolean
}

function msToHMS(ms: number) {
  if (ms <= 0) return '00:00:00'
  const s = Math.floor(ms / 1000)
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  return [h, m, sec].map(v => String(v).padStart(2, '0')).join(':')
}

export function SLATimer({ deadline, breached }: Props) {
  const [remaining, setRemaining] = useState(0)

  useEffect(() => {
    if (!deadline) return
    const update = () => setRemaining(new Date(deadline).getTime() - Date.now())
    update()
    const id = setInterval(update, 1000)
    return () => clearInterval(id)
  }, [deadline])

  if (!deadline) return null

  const isOverdue = breached || remaining <= 0
  const isWarning = !isOverdue && remaining < 2 * 3600 * 1000

  return (
    <div className={cn(
      'flex items-center gap-1.5 text-xs font-medium px-2 py-1 rounded',
      isOverdue ? 'bg-red-100 text-red-700' : isWarning ? 'bg-yellow-100 text-yellow-700' : 'bg-green-100 text-green-700',
    )}>
      {isOverdue ? <AlertTriangle className="w-3.5 h-3.5" /> : <Clock className="w-3.5 h-3.5" />}
      {isOverdue ? 'SLA Breached' : `SLA: ${msToHMS(remaining)}`}
    </div>
  )
}
